export function logout(redirectUrl?: string) {
  window.localStorage.clear();
  window.location.replace(
    `/api/auth/logout${redirectUrl ? `?redirect=${redirectUrl}` : ""}`
  );
}
